import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';

const API_BASE_URL = 'https://api.citynewsservice.cn/v1';
const IMAGE_BASE_URL = 'https://obj.citynewsservice.cn';

export default class WeeklyQuizPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    
    this.quizItems = [];
    this.loading = false;
    this.loadingMore = false;
    this.hasMore = true;
    this.currentPage = 1;
    this.totalPages = 1;
    this.error = null;
    
    // 加载第一页数据
    this.loadQuizzes(1);
  }

  async loadQuizzes(page = 1) {
    if (this.loading && page === 1) return;
    
    if (page === 1) {
      this.loading = true;
    } else {
      this.loadingMore = true;
    }
    
    this.error = null;
    
    try {
      // 使用 Flarum 的内部 API 路由，避免 CORS 问题
      const url = app.forum.attribute('apiUrl') + '/weekly-quiz/list';
      
      const response = await app.request({
        method: 'GET',
        url: url,
        params: {
          page: page,
          limit: 9,
          sortedBy: 'desc',
          orderBy: 'created_at',
        },
      });
      
      const data = response;
      
      if (data.data) {
        // const newItems = data.data.map((quiz) => {
        //   // 处理图片 URL：如果 cover 是完整 URL 则直接使用，否则拼接 API base URL
        //   let imageUrl = null;
        //   if (quiz.cover) {
        //     if (quiz.cover.startsWith('http://') || quiz.cover.startsWith('https://')) {
        //       imageUrl = quiz.cover;
        //     } else {
        //       // 移除开头的斜杠（如果有）
        //       const coverPath = quiz.cover.startsWith('/') ? quiz.cover.substring(1) : quiz.cover;
        //       imageUrl = `${API_BASE_URL}/${coverPath}`;
        //     }
        //   }
          
        //   return {
        //     id: quiz.qid,
        //     image: imageUrl,
        //     title: quiz.title_en || quiz.name_en || '',
        //     date: quiz.created_at || '',
        //   };
        // });
        
        if (page === 1) {
          this.quizItems = data.data;
        } else {
          this.quizItems = [...this.quizItems, ...data.data];
        }
        
        // 更新分页信息
        if (data.meta && data.meta.pagination) {
          this.currentPage = data.meta.pagination.current_page;
          this.totalPages = data.meta.pagination.total_pages;
          this.hasMore = this.currentPage < this.totalPages;
        }
      }
    } catch (error) {
      console.error('Error loading quizzes:', error);
      // 处理 Flarum 的 API 错误响应
      if (error.response && error.response.errors) {
        const errorMessages = error.response.errors.map(e => e.detail || e.title).join(', ');
        this.error = errorMessages || 'Failed to load quizzes';
      } else {
        this.error = error.message || 'Failed to load quizzes';
      }
    } finally {
      this.loading = false;
      this.loadingMore = false;
      m.redraw();
    }
  }

  loadMore() {
    if (this.loadingMore || !this.hasMore) return;
    
    const nextPage = this.currentPage + 1;
    this.loadQuizzes(nextPage);
  }

  handleQuizClick(qid) {
    if (!qid) {
      console.warn('Quiz ID (qid) is missing');
      return;
    }
    
    // 构建跳转 URL：https://www.citynewsservice.cn/quiz?qid={qid}
    const quizUrl = `https://www.citynewsservice.cn/quiz?qid=${encodeURIComponent(qid)}`;
    
    // 在新窗口打开
    window.open(quizUrl, '_blank', 'noopener,noreferrer');
  }

  view() {
    return (
      <div className="WeeklyQuizPage">
        {/* 渐变背景 */}
        <div className="WeeklyQuizPage-background">
          {/* 顶部横幅 */}
          <div className="WeeklyQuizPage-banner">
            <img src={app.forum.attribute('baseUrl') + '/assets/images/title-weekly-quiz.png'} alt="Weekly Quiz Banner" />
          </div>

          {/* 主要内容区域 */}
          <div className="WeeklyQuizPage-container">
            {/* 加载状态 */}
            {this.loading && this.quizItems.length === 0 && (
              <div className="WeeklyQuizPage-loading">
                <div className="LoadingIndicator" />
              </div>
            )}

            {/* 错误信息 */}
            {this.error && (
              <div className="WeeklyQuizPage-error">
                <p>{this.error}</p>
                <Button
                  className="Button Button--primary"
                  onclick={() => this.loadQuizzes(1)}
                >
                  Retry
                </Button>
              </div>
            )}

            {/* 卡片网格 */}
            {!this.loading && !this.error && (
              <>
                <div className="WeeklyQuizPage-grid">
                  {this.quizItems.map((item) => (
                    <div 
                      key={item.qid || item.id} 
                      className="WeeklyQuizPage-card"
                      onclick={() => this.handleQuizClick(item.qid)}
                    >
                      <div className="WeeklyQuizPage-card-image">
                        {item.cover ? (
                          <img src={IMAGE_BASE_URL + '/' + item.cover} alt={item.name_en} onerror={(e) => {
                            e.target.src = API_BASE_URL + '/' + item.cover;
                          }} />
                        ) : (
                          <div className="WeeklyQuizPage-card-placeholder">No Image</div>
                        )}
                      </div>
                      <div className="WeeklyQuizPage-card-content">
                        <div className="WeeklyQuizPage-card-title">{item.name_en}</div>
                        <div className="WeeklyQuizPage-card-date">{item.created_at}</div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* 加载更多按钮 */}
                {this.hasMore && (
                  <div className="WeeklyQuizPage-load-more">
                    <Button
                      className="Button WeeklyQuizPage-load-more-button"
                      onclick={this.loadMore.bind(this)}
                      loading={this.loadingMore}
                      disabled={this.loadingMore}
                    >
                      Load more...
                    </Button>
                  </div>
                )}

                {/* 没有更多数据 */}
                {!this.hasMore && this.quizItems.length > 0 && (
                  <div className="WeeklyQuizPage-no-more">
                    <p>No more quizzes to load</p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  title() {
    return 'Weekly Quiz';
  }
}

